import React, { useState } from "react";
import { Box, Button, Checkbox, Menu, MenuItem } from "@mui/material";
import { IconColumns } from "@tabler/icons-react";
import tokens from "../../theme/tokens";

const { color, font, radius } = tokens;

/**
 * Picks which screening_data fields appear as columns on the Screening tab.
 *
 * The menu is built from the data (see availableFields), not from a hardcoded list, so a field the
 * AI starts capturing next month becomes selectable with no code change. That's the point of the
 * feature: this menu is where "the webhook's schema grew" becomes visible to a recruiter.
 *
 * Renders nothing when no candidate on this job has any screening_data — an empty menu button is
 * just a dead control.
 */
const ColumnPicker = ({ fields = [], selected = [], onToggle }) => {
  const [anchor, setAnchor] = useState(null);

  if (!fields.length) return null;

  return (
    <>
      <Button
        onClick={(e) => setAnchor(e.currentTarget)}
        startIcon={<IconColumns size={14} stroke={2} />}
        sx={{
          font: `500 12px ${font.sans}`,
          color: color.textSecondary,
          border: `1px solid ${color.border}`,
          borderRadius: `${radius.button}px`,
          px: 1.25,
          py: 0.5,
          textTransform: "none",
          "&:hover": { bgcolor: color.rowTint },
        }}
      >
        Columns
      </Button>

      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {fields.map((field) => (
          <MenuItem
            key={field.key}
            onClick={() => onToggle(field.key)}
            sx={{ font: `400 12.5px ${font.sans}`, color: color.text, py: 0.25 }}
          >
            <Checkbox
              size="small"
              checked={selected.includes(field.key)}
              sx={{ p: 0.5, mr: 1 }}
            />
            <Box>{field.label}</Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ColumnPicker;
